
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m20.286 12.223-3.25-2L17 10.2V6.65l-.728-.436-5-3-.772-.463-.772.463-5 3L4 6.65V21h17v-8.338l-.714-.44ZM13 19.5v-6l3.25-2 3.25 2v6H13Zm-7.5-12 5-3 5 3v2.7l-.036.023-3.25 2-.714.439V19.5h-6v-12Zm3.5 2H7.5V11H9V9.5Zm8 5.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM13.5 9.5H12V11h1.5V9.5Zm-6 4.5H9v1.5H7.5V14Z"}})])
          )
        }
      }
    